import React from 'react';
import { useTranslation } from 'react-i18next';
import { ArticleMode } from '../../types/articleGeneration';

interface Props {
  mode: ArticleMode;
  onChange: (mode: ArticleMode) => void;
}

const MODES: ArticleMode[] = ['full_article', 'headings', 'headings_briefs'];

const ModeSelector: React.FC<Props> = ({ mode, onChange }) => {
  const { t } = useTranslation();
  return (
    <div>
      <label className="block text-sm font-medium mb-2">{t('article.mode_label')}</label>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3" role="radiogroup">
        {MODES.map((m) => (
          <button
            key={m}
            type="button"
            role="radio"
            aria-checked={mode === m}
            onClick={() => onChange(m)}
            className={`p-4 border rounded-lg text-left transition-colors duration-200 ${
              mode === m
                ? 'border-blue-600 bg-blue-50 ring-1 ring-blue-600'
                : 'border-gray-300 hover:border-gray-400'
            }`}
          >
            <div className="font-semibold">{t(`article.mode_${m}`)}</div>
            <div className="text-sm text-gray-600 mt-1">{t(`article.mode_${m}_desc`)}</div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ModeSelector;
